import React, { useState, useRef, useContext, useEffect } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { AppDataContext, VLink } from "../AppDataContext"
import useNetwork from '../../useNetwork';
import { Loader } from '../Loader';
import CurrencyFormat from 'react-currency-format';
import useInfiniteScroll from "../../useInfiniteScroll";
import { Pickup } from '../../../src/components/account/Pickup';
import { ConfirmDialog } from '../ConfirmDialog';
import { Modal } from 'bootstrap';

export function Invoices(props) {

    const context = useContext(AppDataContext);
    const { loading, networkError, netRequest, netRenderError } = useNetwork(false);
	const [invoices, setInvoices] = useState([]);
	const totalInvoices = useRef(null);

	function loadInvoices(fromBeginning) {
		const getNextInvoices = async (startingAt) => {
			if (totalInvoices.current == null || startingAt < totalInvoices.current) {
				const url = 'api/site/GetInvoices/' + startingAt + '/' + pageSize;

				const response = await netRequest(url);

				if (response.data != null) {
					setStartIx(startingAt + pageSize);
					totalInvoices.current = response.data.totalRows;

					if (startingAt == 0)
						setInvoices(response.data.data);
					else
						setInvoices([...invoices, ...response.data.data]);

					if (response.data.length == 0)
						setIsDone(true);
				} else {
					setIsDone(true);
				}

				setIsFetching(false);
			}
		};
		var startAt = fromBeginning === true ? 0 : startIx;
		getNextInvoices(startAt);
	}

	const [isFetching, setIsFetching, isDone, setIsDone] = useInfiniteScroll(loadInvoices);
	const [startIx, setStartIx] = useState(0);
	const [pageSize, setPageSize] = useState(8);
	const [selectedInvoice, setSelectedInvoice] = useState(null);
	const [successMessage, setSuccessMessage] = useState(null);
	const [errorMessage, setErrorMessage] = useState(null);

	useEffect(() => {
		loadInvoices(true);
	}, []);

	const [randomNumberOpener, setRandomNumberOpener] = useState(null);
	const [invoiceId, setInvoiceId] = useState(null);
	const [openPickupDialog, setOpenPickupDialog] = useState(false);

	const notifyPickupOpening = (id) => {
		setInvoiceId(id);
		setOpenPickupDialog(true);
	};

	useEffect(() => {
		if (openPickupDialog) {
			setRandomNumberOpener(Math.random());
			(new Modal("#pickupModal")).show();
		}
		setOpenPickupDialog(false);
	}, [openPickupDialog]);

	const notifySlotSelected = (slotTime) => {

		// find invoice, set date, and reset the invoices array
		const ix = invoices.findIndex(x => x.secureId == invoiceId);
		invoices[ix].pickupTimeStr = slotTime;
		setInvoices([...invoices]);

		//loadInvoices(true);
		setInvoiceId(null);		
	};


	const clickMakePayment = async () => {
		setSuccessMessage(null);
		setErrorMessage(null);

		const url = 'api/site/makepayment/';

		const resp = await netRequest(url, { Param: selectedInvoice.secureId });

		if (resp.isError) {
			return "An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")";
		} else if (resp.data?.message) {
			setErrorMessage(resp.data.message);
		} else {
			var message = "Payment has been made.";
			if (selectedInvoice.hasScheduler && selectedInvoice.pickupTimesAvailable) {
				message += " You may now schedule pickup by clicking on the button, below.";
			}
			setSuccessMessage(message);
			loadInvoices(true);
			return null;
		}

	}

    //if (networkError) {
    //    //return netRenderError();
    //    if (networkError === "Unauthorized") {
    //        return <Redirect to="/login" />;
    //    }
    //    return <Redirect to="/error" status={networkError} />

    //}
    //if (loading)
    //    return <></>

    return (
		<>
			<ConfirmDialog cancelText="No" okText="Yes"
				okClicked={clickMakePayment}
				id="paymentConfirmModal"
				headerText="Confirm Payment?"
			>
				<p>Pay your invoice for &nbsp;
					<CurrencyFormat decimalScale={2} fixedDecimalScale={true} value={selectedInvoice?.amountDue} displayType={'text'} thousandSeparator={true} prefix={'$'} />
					&nbsp; now with your {context.brand} ending in {context.last4}?</p>
				<p>Note: If you want to change your payment method, you must change your card in Payment Settings</p>
			</ConfirmDialog>

			<Loader loading={loading} />
			<Helmet>
				<title>Invoices</title>
			</Helmet>

            {successMessage &&
                <div class="row mt-3"><div class="col-12 mb-3">
                    <div class="alert alert-success">{successMessage}</div>
                </div>
                </div>
            }
            {errorMessage &&
                <div class="row mt-3"><div class="col-12 mb-3">
                    <div class="alert alert-danger">{errorMessage}</div>
                </div>
                </div>
            }
			<div class="tab-content">
				<div class="tab-pane container h-100 pt-3 px-0 active  background-white mt-3" id="all">
						<div class="table-responsive">
							<table class="mb-1 table align-middle table-borderless table-striped">
								<thead>
									<tr>
										<th scope="col">Invoice #</th>
										<th scope="col">Auction</th>
										<th scope="col" class="text-center">Payment Status</th>
										<th scope="col" class="text-end">Invoice Total</th>
									<th scope="col" class="text-end">Pick Up Date</th>
									</tr>
								</thead>
								<tbody>
									{invoices.map((i) => (
										<tr>
											<td>
												<VLink to={'/dashboard/invoice/' + i.secureId}>{i.invoiceNumber}</VLink>							
											</td>
											<td>
												{i.auctionSessions.length === 1 ?
														<VLink class="new-window-icon text-uppercase" target="_blank" to={'/auction/' + i.auctionSessions[0].auctionSessionSecureId}>{i.auctionTitle}</VLink>							
													:
													i.auctionSessions.map((ase, ix) => (
														<VLink class="new-window-icon text-uppercase" target="_blank" to={'/auction/' + ase.auctionSessionSecureId}>{(ix === 0 ? i.auctionTitle : "") + " " + ase.sessionName}</VLink>							
													))
												}						
											</td>
											<td class="text-center">
												<label className={"auction-label " + (i.paymentStatus == "Paid" ? "paid" : "pending")}>
													{i.paymentStatus}
												</label>
											</td>
											<td class="text-end">
												<CurrencyFormat decimalScale={2} fixedDecimalScale={true} value={i.invoiceTotal} displayType={'text'} thousandSeparator={true} prefix={'$'} />
											</td>
											<td class="text-end">
												{i.paymentStatus == "NoPaymentMethod" ?
													<VLink to='/account/payment'>Add Card</VLink>
												:
													(i.paymentStatus == "Unpaid" || i.paymentStatus == "Declined") ?
															<button class="btn mx-auto btn-sm btn-primary  badge w-100"
																data-bs-toggle="modal" data-bs-target="#paymentConfirmModal"
																onClick={() => setSelectedInvoice(i)}
															>Pay Now</button>
													:
														i.hasScheduler ?
															i.pickupTimeStr == null ?
																	i.pickupTimesAvailable ?
																		<button   onClick={() => notifyPickupOpening(i.secureId)} class="btn btn-primary btn-sm badge w-100">Select Pickup Slot</button>	
																	:
																		<></>
															:
																<>{i.pickupTimeStr}</>
														:
															<>{i.pickupTimeStr}</>
												}
											</td>
										</tr>
									)) }
								</tbody>
							</table>
						</div>

					</div>
				</div>							

 		
			{invoiceId &&
				<Pickup randomNumberOpener={randomNumberOpener} modalId="pickupModal" invoiceId={invoiceId} notifySlotSelected={notifySlotSelected} />
			}
		</>
    );

}
